import { Button, Table,Spin, Tag, message} from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react'
import {Col, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import {AUTH_URL} from '../constants';
import { TfiReload } from 'react-icons/tfi';

import { IoEnterSharp } from "react-icons/io5"
import { IoMdArrowDropright } from 'react-icons/io';
import { selectUserDetails } from '../features/auth/authSlice';
import { useSelector } from 'react-redux';
import { INotification } from '../factory/interfaces';
import { notify, notify_success, toastStyle } from '../pages/LoginPage';

const NotificationsTable = () => {
    const dispatch = useDispatch()
    const [reloadComponent, setReloadComponent] = useState(false)
    const [notifications, setNotifications]= useState<INotification[]>()
    const [resendingSMS, setResendingSMS] = useState(false)
  

     //Redux states
    const userDetails = useSelector(selectUserDetails)
    const isAdmin = userDetails?.role === 'admin'
    const metadata = useSelector((state: any) => state.metadata)

    //Functions

    const handleResendSms = async(record: any)=>{
      
      try {
      setResendingSMS(true)

      const response = await axios.post(`${AUTH_URL}/notifications/resend-sms`,{sms_id: record._id}, {withCredentials: true})
      setResendingSMS(false)
      if(response.data.success){

      message.success(response.data.message)
      }else{
  
      message.error(response.data.message)
      }
        
      } catch (error:any) {
        setResendingSMS(false)
        message.error(error.message)
        
      }
    }

 const columns = [
    {
    title: 'No.',
    dataIndex: 'count',
    width: 60,
    render: (text:any, record:any, index:any) => index + 1,
  },
  {
    title: 'Recipient',
    dataIndex: 'recipient',
    key: 'recipient',
    width: 250,
    fixed: 'left' as any,
  },
  {
    title: 'Phone',
    dataIndex: 'phone',
    key: 'phone',
    width: 150,

  },
  {
    title: 'Message',
    dataIndex: 'message',
    key: 'message',
    width: 700,
  },
  {
    title: 'Cost (UGX)',
    dataIndex: 'cost',
    key: 'cost',
    width: 100,
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    width: 100,
    fixed: 'right' as const,
    render: (text: string, notification: INotification)=> {
      return (
            <Tag 
              style={{width: '100%', textAlign:'center'}} 
              className='rounded-0' 
              color={(notification.status === 'SENT') ? 'green' : (notification.status === 'PENDING') ? 'magenta' : 'red'} 
              key={notification._id}>
              { (notification.status ? notification.status : '').toUpperCase()}
            </Tag>
      )

    }
  },

]

    const getNotifications = async()=>{
      try {

        const response = await axios.get(`${AUTH_URL}/notifications`, {withCredentials: true})
        if(response.data.success){
          setNotifications(response.data.notifications)
        }else{
          notify(response.data.message, toastStyle)
        }
        
      } catch (error:any) {

        notify(error.message, toastStyle)
        
      }
     
    }


  useEffect(()=>{
    if(reloadComponent){
        getNotifications()
        setReloadComponent(false)
    }
}, [reloadComponent])

  useEffect(()=>{
    getNotifications()

  }, [dispatch])

  return (
    <>
    {notifications? 
    <>

    <Row className=' justify-content-between align-items-center py-0 g-0'>
        <Col className='text-start py-2'>
         <h4 className='medium text-uppercase fw-bold' style={{color: '#052c65', fontSize: 16}}> <IoMdArrowDropright />Notifications</h4>

         </Col>
    

         <Col className='text-end py-2'>
            <Button type='primary' className='rounded-0 mx-1'> <IoEnterSharp style={{marginRight: '5px'}} /> <span>Send a test sms</span></Button>
            <Button  className='rounded-0' type="dashed"> <TfiReload/> <span className='mx-1'>Reload</span></Button>
         </Col>
            
        </Row>
    
     {
      notifications &&
        <Table className='rounded-0 transactions-table'         id='dlms-notifications-data' bordered dataSource={notifications} columns={columns} 
        tableLayout='fixed'
        style={{overflow: 'auto'}} 
       />
     }
     
      </> : 
        <Spin style={{paddingTop: 100}} tip="Loading notifications..." size="large">
        <div className="content" />
      </Spin>

    }
    </>
  )
}

export default NotificationsTable